import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
import { Hero } from "./components/sections/Hero";
import { Story } from "./components/sections/Story";
import { WorkToward } from "./components/sections/WorkToward";
import { BeforeAfter } from "./components/sections/BeforeAfter";
import { Challenges } from "./components/sections/Challenges";
import { Introducing } from "./components/sections/Introducing";
import { Volumes } from "./components/sections/Volumes";
import { Tools } from "./components/sections/Tools";
import { Bonuses } from "./components/sections/Bonuses";
import { ValueStack } from "./components/sections/ValueStack";
import { IntroOffer } from "./components/sections/IntroOffer";
import { Testimonials } from "./components/sections/Testimonials";
import { Author } from "./components/sections/Author";
import { Faq } from "./components/sections/Faq";
import { FinalCta } from "./components/sections/FinalCta";
import { Footer } from "./components/sections/Footer";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream font-sans text-navy" data-id="element-0" data-mp="3mjq2lgp4euvl">
      <MetaPixel data-id="element-1" data-mp="3rcsw5otwe4bs" />
      <Hero data-id="element-2" data-mp="3recd7hndojem" />
      <main data-id="element-3" data-mp="3relwkmdx3sbc">
        <Story data-id="element-4" data-mp="5or2zhbcs60" />
        <WorkToward data-id="element-5" data-mp="67yhm9c7y5s" />
        <BeforeAfter data-id="element-6" data-mp="4n6a3ahwrb3" />
        <Challenges data-id="element-7" data-mp="56qxrrj5tst" />
        <Introducing data-id="element-8" data-mp="2zl3alhpbj03q" />
        <Volumes data-id="element-9" data-mp="2zllcouynw8jk" />
        <Tools data-id="element-10" data-mp="2zm4xcjfp5b1a" />
        <Bonuses data-id="element-11" data-mp="2zmo6bandcp36" />
        <ValueStack data-id="element-12" data-mp="2zn6biws0edn8" />
        <IntroOffer data-id="element-13" data-mp="33mowfsjtyoq2" />
        <Testimonials data-id="element-14" data-mp="33lwxq8uxsavk" />
        <Author data-id="element-15" data-mp="33nggq77z9011" />
        <Faq data-id="element-16" data-mp="33mykhalbelt4" />
        <FinalCta data-id="element-17" data-mp="33oi337ug18y2" />
      </main>
      <Footer data-id="element-18" data-mp="38l8j5v6904jh" />
      <FloatingCta data-id="element-19" data-mp="38kqcs5pvg9xu" />
      <PurchasePopup data-id="element-20" data-mp="38k6ugnwb7jja" />
    </div>;
}